import React, { useEffect } from "react";
import Menu from "../components/Menu";
import { setTitle } from "../helpers/title";
import { useCookies } from "react-cookie";
import Back from "../components/Back";
import ProfileUser from "../components/ProfileUser";
import { handleLogout } from "../helpers/auth";

export default function Profile() {
  const [cookies, removeCookie] = useCookies(["auth", "user"]);

  useEffect(() => {
    setTitle(`${cookies.user.name} | Profil`);
  }, [cookies]);

  return (
    <div>
      <div className="container" />
      <Back title="Profil" />
      <div className="content">
        <ProfileUser logout={() => handleLogout(removeCookie)} />
      </div>
      <Menu />
    </div>
  );
}
